export const proxyHashErrors = [
    {
        text: 'CannotAuthoriseSelf',
        hash: '0xa9cefcae'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'CannotAuthoriseSelf',
        hash: '0xa9cefcae'
    },
    {
        text: 'InvalidContract',
        hash: '0x6eefed20'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'CalldataEmptyButInitNotZero',
        hash: '0x42200566'
    },
    {
        text: 'FacetAddressIsNotZero',
        hash: '0x79c9df22'
    },
    {
        text: 'FacetAddressIsZero',
        hash: '0xc68ec83a'
    },
    {
        text: 'FacetContainsNoCode',
        hash: '0xe3500600'
    },
    {
        text: 'FunctionAlreadyExists',
        hash: '0xa023275d'
    },
    {
        text: 'FunctionDoesNotExist',
        hash: '0xa9ad62f8'
    },
    {
        text: 'FunctionIsImmutable',
        hash: '0xc3c5ec37'
    },
    {
        text: 'IncorrectFacetCutAction',
        hash: '0xe548e6b5'
    },
    {
        text: 'InitReverted',
        hash: '0xc53ebed5'
    },
    {
        text: 'InitZeroButCalldataNotEmpty',
        hash: '0x98116860'
    },
    {
        text: 'NoSelectorsInFace',
        hash: '0x7bc55950'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'AlreadyInitialized',
        hash: '0x0dc149f0'
    },
    {
        text: 'FeeTooHigh',
        hash: '0xcd4e6167'
    },
    {
        text: 'InvalidFee',
        hash: '0x58d620b3'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'ReentrancyError',
        hash: '0x29f745a7'
    },
    {
        text: 'ShareTooHigh',
        hash: '0x2a07fc4c'
    },
    {
        text: 'TokenAddressIsZero',
        hash: '0xdc2e5e8d'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'ZeroAddress',
        hash: '0xd92e233d'
    },
    {
        text: 'CannotBridgeToSameNetwork',
        hash: '0x4ac09ad3'
    },
    {
        text: 'ContractCallNotAllowed',
        hash: '0x94539804'
    },
    {
        text: 'CumulativeSlippageTooHigh',
        hash: '0x65ec4880'
    },
    {
        text: 'InformationMismatch',
        hash: '0x50dc905c'
    },
    {
        text: 'InsufficientBalance',
        hash: '0xf4d678b8'
    },
    {
        text: 'InvalidAmount',
        hash: '0x2c5211c6'
    },
    {
        text: 'InvalidContract',
        hash: '0x6eefed20'
    },
    {
        text: 'InvalidReceiver',
        hash: '0x1e4ec46b'
    },
    {
        text: 'LengthMissmatch',
        hash: '0xd4e105db'
    },
    {
        text: 'NativeAssetTransferFailed',
        hash: '0x5a046737'
    },
    {
        text: 'NoSwapDataProvided',
        hash: '0x0503c3ed'
    },
    {
        text: 'NoSwapFromZeroBalance',
        hash: '0xe46e079c'
    },
    {
        text: 'NoTransferToNullAddress',
        hash: '0x21f74345'
    },
    {
        text: 'NullAddrIsNotAValidSpender',
        hash: '0x63ba9bff'
    },
    {
        text: 'NullAddrIsNotAnERC20Token',
        hash: '0xd1bebf0c'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'ReentrancyError',
        hash: '0x29f745a7'
    },
    {
        text: 'SliceOutOfBounds',
        hash: '0x3b99b53d'
    },
    {
        text: 'SliceOverflow',
        hash: '0x47aaf07a'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'ContractCallNotAllowed',
        hash: '0x94539804'
    },
    {
        text: 'CumulativeSlippageTooHigh',
        hash: '0x65ec4880'
    },
    {
        text: 'InsufficientBalance',
        hash: '0xf4d678b8'
    },
    {
        text: 'InvalidAmount',
        hash: '0x2c5211c6'
    },
    {
        text: 'InvalidContract',
        hash: '0x6eefed20'
    },
    {
        text: 'InvalidReceiver',
        hash: '0x1e4ec46b'
    },
    {
        text: 'NativeAssetTransferFailed',
        hash: '0x5a046737'
    },
    {
        text: 'NoSwapDataProvided',
        hash: '0x0503c3ed'
    },
    {
        text: 'NoSwapFromZeroBalance',
        hash: '0xe46e079c'
    },
    {
        text: 'NoTransferToNullAddress',
        hash: '0x21f74345'
    },
    {
        text: 'NullAddrIsNotAValidSpender',
        hash: '0x63ba9bff'
    },
    {
        text: 'NullAddrIsNotAnERC20Token',
        hash: '0xd1bebf0c'
    },
    {
        text: 'ReentrancyError',
        hash: '0x29f745a7'
    },
    {
        text: 'SliceOutOfBounds',
        hash: '0x3b99b53d'
    },
    {
        text: 'SliceOverflow',
        hash: '0x47aaf07a'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'AlreadyInitialized',
        hash: '0x0dc149f0'
    },
    {
        text: 'CannotBridgeToSameNetwork',
        hash: '0x4ac09ad3'
    },
    {
        text: 'ContractCallNotAllowed',
        hash: '0x94539804'
    },
    {
        text: 'CumulativeSlippageTooHigh',
        hash: '0x65ec4880'
    },
    {
        text: 'InformationMismatch',
        hash: '0x50dc905c'
    },
    {
        text: 'InsufficientBalance',
        hash: '0xf4d678b8'
    },
    {
        text: 'InvalidAmount',
        hash: '0x2c5211c6'
    },
    {
        text: 'InvalidConfig',
        hash: '0x35be3ac8'
    },
    {
        text: 'InvalidContract',
        hash: '0x6eefed20'
    },
    {
        text: 'InvalidReceiver',
        hash: '0x1e4ec46b'
    },
    {
        text: 'InvalidRouter',
        hash: '0x466d7fef'
    },
    {
        text: 'NativeAssetTransferFailed',
        hash: '0x5a046737'
    },
    {
        text: 'NoSwapDataProvided',
        hash: '0x0503c3ed'
    },
    {
        text: 'NoSwapFromZeroBalance',
        hash: '0xe46e079c'
    },
    {
        text: 'NoTransferToNullAddress',
        hash: '0x21f74345'
    },
    {
        text: 'NotInitialized',
        hash: '0x87138d5c'
    },
    {
        text: 'NullAddrIsNotAValidSpender',
        hash: '0x63ba9bff'
    },
    {
        text: 'NullAddrIsNotAnERC20Token',
        hash: '0xd1bebf0c'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'ReentrancyError',
        hash: '0x29f745a7'
    },
    {
        text: 'SliceOutOfBounds',
        hash: '0x3b99b53d'
    },
    {
        text: 'SliceOverflow',
        hash: '0x47aaf07a'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'NewOwnerMustNotBeSelf',
        hash: '0xbf1ea9fb'
    },
    {
        text: 'NoNullOwner',
        hash: '0x1beca374'
    },
    {
        text: 'NoPendingOwnershipTransfer',
        hash: '0x75cdea12'
    },
    {
        text: 'NotPendingOwner',
        hash: '0x1853971c'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'AlreadyInitialized',
        hash: '0x0dc149f0'
    },
    {
        text: 'CannotBridgeToSameNetwork',
        hash: '0x4ac09ad3'
    },
    {
        text: 'ContractCallNotAllowed',
        hash: '0x94539804'
    },
    {
        text: 'CumulativeSlippageTooHigh',
        hash: '0x65ec4880'
    },
    {
        text: 'InformationMismatch',
        hash: '0x50dc905c'
    },
    {
        text: 'InsufficientBalance',
        hash: '0xf4d678b8'
    },
    {
        text: 'InvalidAmount',
        hash: '0x2c5211c6'
    },
    {
        text: 'InvalidConfig',
        hash: '0x35be3ac8'
    },
    {
        text: 'InvalidContract',
        hash: '0x6eefed20'
    },
    {
        text: 'InvalidReceiver',
        hash: '0x1e4ec46b'
    },
    {
        text: 'InvalidStargateRouter',
        hash: '0x1aba923d'
    },
    {
        text: 'NativeAssetNotSupported',
        hash: '0x5ded5997'
    },
    {
        text: 'NativeAssetTransferFailed',
        hash: '0x5a046737'
    },
    {
        text: 'NoSwapDataProvided',
        hash: '0x0503c3ed'
    },
    {
        text: 'NoSwapFromZeroBalance',
        hash: '0xe46e079c'
    },
    {
        text: 'NoTransferToNullAddress',
        hash: '0x21f74345'
    },
    {
        text: 'NotInitialized',
        hash: '0x87138d5c'
    },
    {
        text: 'NullAddrIsNotAValidSpender',
        hash: '0x63ba9bff'
    },
    {
        text: 'NullAddrIsNotAnERC20Token',
        hash: '0xd1bebf0c'
    },
    {
        text: 'OnlyContractOwner',
        hash: '0x277d76f8'
    },
    {
        text: 'ReentrancyError',
        hash: '0x29f745a7'
    },
    {
        text: 'SliceOutOfBounds',
        hash: '0x3b99b53d'
    },
    {
        text: 'SliceOverflow',
        hash: '0x47aaf07a'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'UnknownLayerZeroChain',
        hash: '0x7c152fe3'
    },
    {
        text: 'UnknownStargatePool',
        hash: '0x59c64529'
    },
    {
        text: 'CannotBridgeToSameNetwork',
        hash: '0x4ac09ad3'
    },
    {
        text: 'ContractCallNotAllowed',
        hash: '0x94539804'
    },
    {
        text: 'CumulativeSlippageTooHigh',
        hash: '0x65ec4880'
    },
    {
        text: 'InformationMismatch',
        hash: '0x50dc905c'
    },
    {
        text: 'InsufficientBalance',
        hash: '0xf4d678b8'
    },
    {
        text: 'InvalidAmount',
        hash: '0x2c5211c6'
    },
    {
        text: 'InvalidContract',
        hash: '0x6eefed20'
    },
    {
        text: 'InvalidReceiver',
        hash: '0x1e4ec46b'
    },
    {
        text: 'NativeAssetTransferFailed',
        hash: '0x5a046737'
    },
    {
        text: 'NoSwapDataProvided',
        hash: '0x0503c3ed'
    },
    {
        text: 'NoSwapFromZeroBalance',
        hash: '0xe46e079c'
    },
    {
        text: 'NoTransferToNullAddress',
        hash: '0x21f74345'
    },
    {
        text: 'NullAddrIsNotAValidSpender',
        hash: '0x63ba9bff'
    },
    {
        text: 'NullAddrIsNotAnERC20Token',
        hash: '0xd1bebf0c'
    },
    {
        text: 'ReentrancyError',
        hash: '0x29f745a7'
    },
    {
        text: 'SliceOutOfBounds',
        hash: '0x3b99b53d'
    },
    {
        text: 'SliceOverflow',
        hash: '0x47aaf07a'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'InsufficientBalance',
        hash: '0xf4d678b8'
    },
    {
        text: 'NativeAssetTransferFailed',
        hash: '0x5a046737'
    },
    {
        text: 'NoTransferToNullAddress',
        hash: '0x21f74345'
    },
    {
        text: 'NotAContract',
        hash: '0x09ee12d5'
    },
    {
        text: 'NullAddrIsNotAnERC20Token',
        hash: '0xd1bebf0c'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'WithdrawFailed',
        hash: '0x750b219c'
    },
    {
        text: 'CannotBridgeToSameNetwork',
        hash: '0x4ac09ad3'
    },
    {
        text: 'ContractCallNotAllowed',
        hash: '0x94539804'
    },
    {
        text: 'CumulativeSlippageTooHigh',
        hash: '0x65ec4880'
    },
    {
        text: 'InformationMismatch',
        hash: '0x50dc905c'
    },
    {
        text: 'InsufficientBalance',
        hash: '0xf4d678b8'
    },
    {
        text: 'InvalidAmount',
        hash: '0x2c5211c6'
    },
    {
        text: 'InvalidContract',
        hash: '0x6eefed20'
    },
    {
        text: 'InvalidReceiver',
        hash: '0x1e4ec46b'
    },
    {
        text: 'NativeAssetTransferFailed',
        hash: '0x5a046737'
    },
    {
        text: 'NoSwapDataProvided',
        hash: '0x0503c3ed'
    },
    {
        text: 'NoSwapFromZeroBalance',
        hash: '0xe46e079c'
    },
    {
        text: 'NoTransferToNullAddress',
        hash: '0x21f74345'
    },
    {
        text: 'NullAddrIsNotAValidSpender',
        hash: '0x63ba9bff'
    },
    {
        text: 'NullAddrIsNotAnERC20Token',
        hash: '0xd1bebf0c'
    },
    {
        text: 'ReentrancyError',
        hash: '0x29f745a7'
    },
    {
        text: 'SliceOutOfBounds',
        hash: '0x3b99b53d'
    },
    {
        text: 'SliceOverflow',
        hash: '0x47aaf07a'
    },
    {
        text: 'UnAuthorized',
        hash: '0xbe245983'
    },
    {
        text: 'AddressOutOfBounds',
        hash: '0x8f95a28a'
    },
    {
        text: 'SliceOutOfBounds',
        hash: '0x3b99b53d'
    },
    {
        text: 'SliceOverflow',
        hash: '0x47aaf07a'
    },
    {
        text: 'UintOutOfBounds',
        hash: '0x85ec83f8'
    },
    {
        text: 'CalldataEmptyButInitNotZero',
        hash: '0x42200566'
    },
    {
        text: 'FacetAddressIsNotZero',
        hash: '0x79c9df22'
    },
    {
        text: 'FacetAddressIsZero',
        hash: '0xc68ec83a'
    },
    {
        text: 'FacetContainsNoCode',
        hash: '0xe3500600'
    },
    {
        text: 'FunctionAlreadyExists',
        hash: '0xa023275d'
    },
    {
        text: 'FunctionDoesNotExist',
        hash: '0xa9ad62f8'
    },
    {
        text: 'FunctionIsImmutable',
        hash: '0xc3c5ec37'
    },
    {
        text: 'IncorrectFacetCutAction',
        hash: '0xe548e6b5'
    },
    {
        text: 'InitReverted',
        hash: '0xc53ebed5'
    },
    {
        text: 'InitZeroButCalldataNotEmpty',
        hash: '0x98116860'
    },
    {
        text: 'NoSelectorsInFace',
        hash: '0x7bc55950'
    }
];
